import WalletsComponent from '../components/wallets/WalletsComponent';

export default function Wallets() {
  return <WalletsComponent />;
}
